/*
  Galleria Thereza · Comprar no Pix ou no cartão (página de produto, carrinho e gaveta).
  Pix: marca o carrinho com o atributo vindi_pix_flow = 1 (o mesmo que o app Vindi Advanced usa)
       e abre o checkout já com 5% de desconto e só o Pix disponível.
  Cartão: garante o carrinho SEM a marcação de Pix e abre o checkout normal (cartão, boleto, Pix sem desconto).
  Na página de produto, antes de seguir, a peça é adicionada ao carrinho com as escolhas do formulário
  (cor, lugares, quantidade) — é o "Compre já" em um clique.
*/
(function () {
  if (window.__gtPagamento) return;
  window.__gtPagamento = true;

  function marcar(pix) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { vindi_pix_flow: pix ? '1' : '' } })
    }).then(function (r) {
      if (!r.ok) throw new Error('');
    });
  }

  function adicionar(secao) {
    var form = document.getElementById('product-form-' + secao);
    if (!form) return Promise.reject(new Error(''));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || '');
        return j;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('[data-gt-pagar]');
    if (!botao) return;
    e.preventDefault();
    if (botao.disabled) return;

    var pix = botao.getAttribute('data-gt-pagar') === 'pix';
    var caixa = botao.closest('.gt-pagar');
    var erro = caixa && caixa.querySelector('.gt-pagar__erro');
    var botoes = caixa ? Array.prototype.slice.call(caixa.querySelectorAll('[data-gt-pagar]')) : [botao];

    botoes.forEach(function (b) { b.disabled = true; });
    botao.classList.add('is-loading');
    if (erro) erro.hidden = true;

    var primeiro = botao.getAttribute('data-gt-origem') === 'produto'
      ? adicionar(botao.getAttribute('data-secao'))
      : Promise.resolve();

    primeiro
      .then(function () { return marcar(pix); })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function (err) {
        botoes.forEach(function (b) { b.disabled = false; });
        botao.classList.remove('is-loading');
        if (erro) {
          erro.textContent = (err && err.message) ? err.message : 'Não foi possível seguir para o pagamento. Tente de novo.';
          erro.hidden = false;
        }
      });
  });
})();
